import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import { Socket } from 'ngx-socket-io';
import { Socket } from 'socket.io-client';
import { MainService } from 'src/app/services/main-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-payment-page',
  templateUrl: './payment-page.component.html',
  styleUrls: ['./payment-page.component.scss']
})
export class PaymentPageComponent implements OnInit {
  accessToken = '';
  amount: any;
  obj = {
    trial_period: false,
    display_logo: '$',
  };
  constructor(public mainService: MainService, private _activated: ActivatedRoute, private _socket: Socket, private router: Router) { }

  ngOnInit() {
    this.mainService.setLoader(true);
    if (this.mainService.paymentRequestPaymentIntent) {
      this.mainService.paymentRequestPaymentIntent.on('token', ($event) => {
        console.log($event, 'token call');
      });
      this.mainService.paymentRequestPaymentIntent.on('paymentmethod', function (event) {
        console.log('in event paymentmethod');
      });
      this.mainService.paymentRequestPaymentIntent.on('source', function (event) {
        console.log('in event source');
      });
      this.mainService.paymentRequestPaymentIntent.on('cancel', function (event) {
        console.log('in event cancel');
      });
    }
    this.mainService.stripeKeySubject.subscribe(data => {
      if (data) {
      this._activated.queryParams
        .subscribe(params => {
          if (params.intent_id && params.client_secret) {
            this.mainService.stripe.retrievePaymentIntent(params.client_secret)
            .then((result) => {
              if (result && result.paymentIntent && result.paymentIntent.status === 'succeeded') {
                this.mainService.customPopups('This link is expired, please generate new QR code', 1);
                return;
              } else {
                if (result && result.paymentIntent && result.paymentIntent.amount) {
                  if (result && result.paymentIntent && result.paymentIntent.id) {
                    const param = {
                      intentId: result.paymentIntent.id,
                    };
                    // tslint:disable-next-line:max-line-length
                    this.mainService.api('post', environment.request_url + 'scanner_page_details', this.mainService.urlParams(param)).subscribe(resp => {
                      console.log(resp);
                      if (resp.is_error === 0) {
                        this.obj.trial_period = resp.trial_period;
                        this.obj.display_logo = resp.doctor_country_currency_info['currency'][0]['display_logo'];
                        this.mainService.currency_data.default_mobile_code = resp.doctor_country_currency_info['country']['mobile_code'];
                        this.mainService.currency_data.display_logo = resp.doctor_country_currency_info['currency'][0]['display_logo'];
                        this.mainService.currency_data.country_code = resp.doctor_country_currency_info['country']['country_code'];
                        this.mainService.currency_data.currency_code = resp.doctor_country_currency_info['currency'][0]['currency_code'];                      }
                    });
                  }
                  setTimeout(() => {
                    this.amount = (parseFloat(result.paymentIntent.amount) / 100).toFixed(2);
                    this.mainService.createStripeElmentsDynamic(params.client_secret, result.paymentIntent.amount);
                  }, 500);

                  setTimeout(() => {
                    // this.mainService.linkAuthenticationElement.mount('#link-authentication-element');
                    this.mainService.stripeAddressElement.mount('#address-element');
                    this.mainService.stripeElement2PaymentIntent.mount('#add_card');
                    this.mainService.paymentRequestPaymentIntent.canMakePayment().then(resp => {
                      console.log('can make payment', resp);
                      if (resp && (resp.applePay || resp.link)) {
                        this.mainService.paymentRequestLinkMethods.mount('#' + 'payment_request_button');
                      } else {
                        if (document.getElementById('payment_request_button')) {
                          document.getElementById('payment_request_button').style.display = 'none';
                        }
                      }
                    });
                    // tslint:disable-next-line:max-line-length
                    this.mainService.socket.emit(this.mainService.socketIDS.START_LOADING, {intent_id: params.intent_id, client_secret: params.client_secret});
                    this.mainService.setLoader(false);
                  },1000);
                }
              }
            });
          }
        });
      }
    });
  }

  handlePaymentChange = (event) => {
    console.log(event);
  }

  confirmPayment(event) {
    // this.mainService.paymentRequestPaymentIntent.on('token').then($event => {
    //   console.log('in event paymentmethod');
    // });
    // this.mainService.paymentRequestPaymentIntent.on('paymentmethod', function(event) {
    //   console.log('in event paymentmethod');
    // });
    // this.mainService.paymentRequestPaymentIntent.on('source', function(event) {
    //   console.log('in event source');
    // });
    // this.mainService.paymentRequestPaymentIntent.on('cancel', function(event) {
    //   console.log('in event cancel');
    // });
    event.preventDefault();
    this.mainService.setLoader(true);
    if (this.mainService.stripePaymentIntent) {
        this.mainService.stripe.confirmPayment({
            elements: this.mainService.stripePaymentIntent,
            confirmParams: {
            // Make sure to change this to your payment completion page
            return_url: environment.request_panel_link + '/success-page'
            },
            redirect: 'if_required'
        }).then(resp => {
            console.log(resp);
          if (resp.error) {
            this.mainService.saveFinancingError({ payment_intent_id: this.mainService.stripePaymentIntent, error_message: resp.error, error_type: "confirmPayment" });
              this.mainService.customPopups(resp.error.message, 2);
              this.mainService.setLoader(false);
            // tslint:disable-next-line:triple-equals
            } else if (resp.paymentIntent && resp.paymentIntent.status == 'succeeded') {
              this.mainService.setLoader(false);
              this.mainService.socket.emit(this.mainService.socketIDS.START_LOADING, {});
              this.router.navigate(['/success-page']);
              this.mainService.successMessage = `<div><b>Thank you! Your transaction was successfully processed.</b></div>
  <div>You can now safely close this window</div>`;
              return false;
            }
        });
    }
}

}
